var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 48 48"}},[_c('path',{attrs:{"d":"M8 21h6v6H8zm0 10h6v6H8zm0-20h6v6H8z"}}),_c('path',{attrs:{"d":"M18 12h22v4H18zm0 10h22v4H18zm0 10h22v4H18z","opacity":".5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }